import { render, staticRenderFns } from "./PlantInfo.vue?vue&type=template&id=60203c97&scoped=true"
import script from "./PlantInfo.vue?vue&type=script&lang=js"
export * from "./PlantInfo.vue?vue&type=script&lang=js"
import style0 from "./PlantInfo.vue?vue&type=style&index=0&id=60203c97&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60203c97",
  null
  
)

export default component.exports